import React, { useState } from 'react';
import { Card, CardContent, CardFooter } from './ui/card';
import { Badge } from './ui/badge';
import { Tabs, TabsContent, TabsList, TabsTrigger } from './ui/tabs';
import { Euro } from 'lucide-react';

export const MenuSection = () => {
  const [activeTab, setActiveTab] = useState('burgers');

  // Burgers Menu Data - Steak origine France 120gr (sauf mention contraire)
  const burgers = [
    {
      name: 'LE TY BREIZH',
      description: 'Pain burger, confit d\'oignons (maison), steak haché 120gr origine France, cheddar, bacon grillé, tomate, salade, sauce au choix',
      price: { simple: '10,00€', double: '14,00€' },
      tag: 'Best-seller',
    },
    {
      name: 'LE TY BIQUETTE',
      description: 'Pain burger, confit d\'oignons (maison), steak haché 120gr origine France, chèvre, tranche de lard grillé, tomate, salade, sauce au choix',
      price: { simple: '10,00€', double: '14,00€' },
    },
    {
      name: 'LE TY CAM',
      description: 'Pain burger, confit d\'oignons (maison), steak haché 120gr origine France, camembert au lait cru, chorizo grillé, tomate, salade, sauce au choix',
      price: { simple: '10,00€', double: '14,00€' },
    },
    {
      name: 'LE TY COMTÉ',
      description: 'Pain burger, steak haché 120gr origine France, comté, cornichons, oignons rouges, roquette, ketchup maison',
      price: { simple: '12,00€', double: '16,00€' },
    },
    {
      name: 'LE DOUBLE CHEESY',
      description: 'Pain burger, salade, tomate, 2 steaks de 85gr origine France, cheddar, cornichons, bacon, ketchup maison',
      price: { simple: '13,00€' },
    },
    {
      name: 'LE TOASTÉ',
      description: 'Pain toasté, tomates, oignons frits, sauce poivre, cheddar, bacon, steak haché 120gr origine France (possibilité de changer de sauce)',
      price: { simple: '12,00€', formule: '16,50€' },
      tag: 'Nouveau',
    },
    {
      name: 'CHEESE SIMPLE',
      description: 'Pain burger, steak haché 85gr origine France, cheddar, cornichons, ketchup maison et oignons frits',
      price: { simple: '8,00€' },
    },
    {
      name: 'CHEESE CHORIZO',
      description: 'Pain burger, sauce ketchup maison, steak haché 85gr origine France, oignons frits, cornichons, cheddar, chorizo (possibilité de changer de sauce)',
      price: { simple: '9,00€' },
    },
    {
      name: 'CHEESE POULET CHORIZO',
      description: 'Pain burger, sauce ketchup maison, nuggets de poulet pané maison, oignons frits, cheddar et chorizo (possibilité de changer de sauce)',
      price: { simple: '9,00€' },
    },
    {
      name: 'LE CRISPY',
      description: 'Pain burger, salade, tomate, filet de poulet pané maison nature ou curry, lard et cheddar, sauce au choix',
      price: { simple: '13,00€', double: '17,00€' },
    },
    {
      name: 'L\'ITALIEN',
      description: 'Pain burger toasté, steak haché 120gr origine France, roquette, tomates confites, parmesan, jambon serrano et pesto maison',
      price: { simple: '13,00€', double: '17,00€' },
      tag: 'Nouveau',
    },
    {
      name: 'L\'ÉLU : L\'ÉCOSSAIS',
      description: 'Pain burger toasté, steak haché 120gr origine France, cheddar maturé, lard grillé, roquette, oignons rouge, sauce whisky 12 ans d\'âge maison',
      price: { simple: '13,00€', double: '17,00€' },
      tag: 'Best-seller',
    },
    {
      name: 'BURGER VG',
      description: 'Pain, salade, tomates, galette de pomme de terre et 1 choix de légumes (confit d\'oignons maison, oignons frits, oignons cru, tomates confites ou poivrons confits maison), 1 choix de fromage (chèvre, cheddar, camembert au lait cru ou comté - raclette +2€ ou reblochon +2€), 1 choix de sauce',
      price: { simple: '10,00€' },
      tag: 'Végétarien',
    },
  ];

  // Pizzas Menu Data (30cm and 40cm)
  const pizzas = [
    {
      name: 'LA MARGHERITA',
      description: 'Sauce tomate, mozza & emmental, jambon, oignons, origan',
      price: { '30cm': '11,00€', '40cm': '16,00€' },
    },
    {
      name: 'LA REINE',
      description: 'Sauce tomate, mozza & emmental, champignons, jambon, olives, origan',
      price: { '30cm': '13,00€', '40cm': '18,00€' },
      tag: 'Classique',
    },
    {
      name: 'LA NAPOLITAINE',
      description: 'Sauce tomate, mozza & emmental, tomates, anchois, olives, origan',
      price: { '30cm': '13,00€', '40cm': '18,00€' },
    },
    {
      name: 'LA ROYALE',
      description: 'Sauce tomate, mozza & emmental, champignons, jambon, origan, œuf',
      price: { '30cm': '13,00€', '40cm': '18,00€' },
    },
    {
      name: 'LA FLAMMEKUECHE',
      description: 'Sauce crème, mozza & emmental, oignons, lardons, persillage maison',
      price: { '30cm': '13,00€', '40cm': '18,00€' },
    },
    {
      name: 'LA 4 FROMAGES',
      description: 'Sauce tomate, mozzarella & emmental, bleu et chèvre',
      price: { '30cm': '13,00€', '40cm': '18,00€' },
    },
    {
      name: 'LA 4 SAISONS',
      description: 'Sauce tomate, mozzarella & emmental, champignons, oignons, poivrons confit maison, olives et pomme de terre',
      price: { '30cm': '13,00€', '40cm': '18,00€' },
    },
    {
      name: 'LA CATALANE',
      description: 'Sauce tomate, mozzarella & emmental, thon, oignons, persillade maison et anchois',
      price: { '30cm': '13,00€', '40cm': '18,00€' },
    },
    {
      name: 'LA MONTAGNARDE',
      description: 'Sauce crème, mozzarella & emmental, jambon blanc, lardons, raclette, jambon serrano et persil',
      price: { '30cm': '14,00€', '40cm': '19,00€' },
      tag: 'Populaire',
    },
    {
      name: 'LA TARTIFLETTE',
      description: 'Sauce crème, mozzarella & emmental, lardons, oignons, pomme de terre et reblochon au lait cru de Savoie',
      price: { '30cm': '14,00€', '40cm': '19,00€' },
    },
    {
      name: 'L\'INDIENNE',
      description: 'Sauce tomate, mozzarella & emmental, tomates, poivrons confit maison, poulet au curry maison et chorizo',
      price: { '30cm': '14,00€', '40cm': '19,00€' },
    },
    {
      name: 'L\'ARIZONA',
      description: 'Sauce tomate, mozzarella & emmental, bœuf épicé, oignons, cheddar et sauce BBQ',
      price: { '30cm': '14,00€', '40cm': '19,00€' },
      tag: 'Populaire',
    },
    {
      name: 'LA SEGUIN',
      description: 'Sauce crème, mozzarella & emmental, tomates, lardons, pomme de terre, miel, chèvre et noix',
      price: { '30cm': '14,00€', '40cm': '19,00€' },
    },
    {
      name: 'LA MÉDITÉRRANÉENNE',
      description: 'Sauce tomate, mozza & emmental, bœuf épicé, confit de poivrons maison, tomates, merguez, origan',
      price: { '30cm': '14,00€', '40cm': '19,00€' },
    },
    {
      name: 'LA NORDIQUE',
      description: 'Crème tomatée, mozza & emmental, fondue de poireaux maison, saumon, aneth, citron',
      price: { '30cm': '16,00€', '40cm': '22,00€' },
      tag: 'Premium',
    },
    {
      name: 'LA PÉRIGOURDINE',
      description: 'Crème tomatée, mozza & emmental, champignons, magret de canard, tomates confites, persillade maison',
      price: { '30cm': '16,00€', '40cm': '22,00€' },
      tag: 'Premium',
    },
    {
      name: 'L\'ITALIENNE',
      description: 'Sauce tomate, mozza & emmental, tomates confites, parmesan, jambon serrano, pesto maison, roquette',
      price: { '30cm': '16,00€', '40cm': '22,00€' },
      tag: 'Populaire',
    },
    {
      name: 'LA CALZONE',
      description: 'Pizza soufflée - Sauce tomate, mozza & emmental, champignons, jambon, origan, œuf, crème',
      price: { '30cm': '15,00€', '40cm': '21,00€' },
      tag: 'Spéciale',
    },
    {
      name: 'CALZONE SAUMON',
      description: 'Pizza soufflée - Sauce tomate, mozzarella & emmental, saumon fumé, fondue de poireaux maison, pomme de terre, oignons, crème, aneth et citron',
      price: { '30cm': '16,00€', '40cm': '22,00€' },
      tag: 'Spéciale',
    },
    {
      name: 'CALZONE VG',
      description: 'Pizza soufflée - Sauce tomate, mozzarella & emmental, tomates, oignons, poivrons confit maison, champignons, crème',
      price: { '30cm': '15,00€', '40cm': '21,00€' },
      tag: 'Végétarien',
    },
  ];

  const renderMenuItem = (item, category) => {
    const tagColors = {
      'Populaire': 'bg-secondary/20 text-secondary-foreground border-secondary/30',
      'Best-seller': 'bg-primary/20 text-primary border-primary/30',
      'Nouveau': 'bg-success/20 text-success-foreground border-success/30',
      'Signature': 'bg-accent/80 text-accent-foreground border-accent',
      'Classique': 'bg-muted text-muted-foreground border-border',
      'Premium': 'bg-primary/30 text-primary border-primary/40',
      'Spéciale': 'bg-secondary/30 text-secondary-foreground border-secondary/40',
      'Végétarien': 'bg-green-500/20 text-green-700 border-green-500/30',
    };

    return (
      <Card key={item.name} className="h-full flex flex-col border-border shadow-soft hover:shadow-medium transition-all duration-300 hover:-translate-y-1 bg-card">
        <CardContent className="p-6 flex-grow">
          <div className="flex items-start justify-between mb-3">
            <h3 className="text-lg font-semibold text-foreground pr-2">{item.name}</h3>
            {item.tag && (
              <Badge variant="outline" className={`${tagColors[item.tag]} text-xs whitespace-nowrap`}>
                {item.tag}
              </Badge>
            )}
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">{item.description}</p>
        </CardContent>
        <CardFooter className="p-6 pt-0 mt-auto">
          <div className="flex flex-wrap items-center gap-3 w-full">
            {category === 'burgers' ? (
              <>
                <div className="flex items-center">
                  <span className="text-sm text-muted-foreground mr-2">{item.price.formule ? 'Seul:' : 'Simple:'}</span>
                  <span className="text-base font-semibold text-primary">{item.price.simple}</span>
                </div>
                {item.price.double && (
                  <>
                    <span className="text-muted-foreground">|</span>
                    <div className="flex items-center">
                      <span className="text-sm text-muted-foreground mr-2">Double:</span>
                      <span className="text-base font-semibold text-primary">{item.price.double}</span>
                    </div>
                  </>
                )}
                {item.price.formule && (
                  <>
                    <span className="text-muted-foreground">|</span>
                    <div className="flex items-center">
                      <span className="text-sm text-muted-foreground mr-2">Formule:</span>
                      <span className="text-base font-semibold text-primary">{item.price.formule}</span>
                    </div>
                  </>
                )}
              </>
            ) : (
              <>
                <div className="flex items-center">
                  <span className="text-sm text-muted-foreground mr-2">30cm:</span>
                  <span className="text-base font-semibold text-primary">{item.price['30cm']}</span>
                </div>
                <span className="text-muted-foreground">|</span>
                <div className="flex items-center">
                  <span className="text-sm text-muted-foreground mr-2">40cm:</span>
                  <span className="text-base font-semibold text-primary">{item.price['40cm']}</span>
                </div>
              </>
            )}
          </div>
        </CardFooter>
      </Card>
    );
  };

  return (
    <section id="menu" className="py-16 sm:py-24 bg-background">
      <div className="container mx-auto px-4 sm:px-6">
        {/* Section Header */}
        <div className="text-center max-w-3xl mx-auto mb-12 sm:mb-16">
          <h2 className="text-4xl sm:text-5xl md:text-6xl font-bold text-foreground mb-4 sm:mb-6">
            Notre Carte
          </h2>
          <p className="text-base sm:text-lg text-muted-foreground leading-relaxed">
            Découvrez nos créations artisanales préparées avec des ingrédients frais et de qualité
          </p>
        </div>

        {/* Menu Tabs */}
        <Tabs defaultValue="burgers" className="w-full" onValueChange={setActiveTab}>
          <TabsList className="grid w-full max-w-md mx-auto grid-cols-2 mb-12 bg-muted">
            <TabsTrigger value="burgers" className="text-base font-medium">
              Burgers
            </TabsTrigger>
            <TabsTrigger value="pizzas" className="text-base font-medium">
              Pizzas
            </TabsTrigger>
          </TabsList>

          {/* Burgers Tab */}
          <TabsContent value="burgers" className="mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {burgers.map((burger) => renderMenuItem(burger, 'burgers'))}
            </div>
          </TabsContent>

          {/* Pizzas Tab */}
          <TabsContent value="pizzas" className="mt-0">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
              {pizzas.map((pizza) => renderMenuItem(pizza, 'pizzas'))}
            </div>
          </TabsContent>
        </Tabs>

        {/* Additional Info */}
        <div className="mt-12 p-6 sm:p-8 bg-muted/50 rounded-lg text-center max-w-4xl mx-auto">
          <p className="text-sm text-muted-foreground mb-2">
            <strong className="text-foreground">🥩 Steak origine France</strong> - 120gr (85gr pour Cheese et Double Cheesy)
          </p>
          <p className="text-sm text-muted-foreground">
            <strong className="text-foreground">Formule +4,50€ :</strong> Inclut votre burger ainsi qu'une frite et une boisson soft 33cl ou eau 50cl
          </p>
          <p className="text-sm text-muted-foreground mt-2">
            <strong className="text-foreground">Formule nuggets +4,50€ :</strong> Ajoutez frites et boisson à vos nuggets
          </p>
          <div className="mt-4 p-4 bg-primary/10 rounded-lg border border-primary/20">
            <p className="text-sm font-medium text-primary">
              🍔 Burger du Mois & 🍕 Pizza du Moment
            </p>
            <p className="text-xs text-muted-foreground mt-1">
              Consultez notre page Facebook pour découvrir nos créations du moment !
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default MenuSection;